// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/widgets/management/archive-portfolio-from-existing/app/css/app.css
// module id = 815
// module chunks = 0